<template>
  <div class="panel">
    <!-- 税 -->
    <div class="divider">{{ $t('421') }}</div>
    <el-form-item :label="$t('446')">
      <el-date-picker
        v-model="staffInfo.tax_start_month"
        type="month"
        value-format="yyyy-MM"
        :placeholder="$t('839')"
        :disabled="show"
      >
      </el-date-picker>
    </el-form-item>
    <br />
    <template v-if="staffInfo.tax_deduction_status !== '2'">
      <!-- 计算规则 -->
      <el-form-item :label="$t('457')" key="tax_rule1" prop="tax_rule">
        <el-select :disabled="show" v-model="staffInfo.tax_rule" :placeholder="$t('221')">
          <el-option
            v-for="item in calculationRule[staffInfo.tax_deduction_status]"
            :key="item.value"
            :label="item.text"
            :value="item.value"
          ></el-option>
        </el-select>
      </el-form-item>
      <!-- 适用税率 -->
      <el-form-item
        :label="$t('basic_info_3')"
        :prop="staffInfo.tax_rule !== '3' ? 'tax_rate' : '' ">
        <!-- staffInfo.tax_rule为个人所得税_新法时置灰 -->
        <el-input
          :disabled="staffInfo.tax_rule === '3' || show"
          v-model="staffInfo.tax_rate"
          v-enterNumberPoint2
          v-enterNumberMax="100"
          placeholder="0.00"
      ><i slot="suffix">%</i>
      </el-input>
      </el-form-item>
    </template>
    <!-- 本年累计固定收入 -->
    <el-form-item :label="$t('944')" prop="salary_last_fix">
      <el-input
        v-model="staffInfo.salary_last_fix"
        v-enterNumberPoint2
        v-enterNumberMax="1000000000"
        placeholder="0.00"
        :disabled="show"
      ></el-input>
    </el-form-item>
    <!-- 本年累计固定收入税额 -->
    <el-form-item :label="$t('1233')" prop="salary_year_accumulate_fix_tax">
      <el-input
        v-model="staffInfo.salary_year_accumulate_fix_tax"
        v-enterNumberPoint2
        v-enterNumberMax="1000000000"
        placeholder="0.00"
        :disabled="show"
      ></el-input>
    </el-form-item>
    <!-- 本年累计非固定收入 -->
    <el-form-item :label="$t('1230')" prop="salary_year_accumulate_notfix">
      <el-input
        v-model="staffInfo.salary_year_accumulate_notfix"
        v-enterNumberPoint2
        v-enterNumberMax="1000000000"
        placeholder="0.00"
        :disabled="show"
      ></el-input>
    </el-form-item>
    <!-- 本年累计非固定收入税额 -->
    <el-form-item :label="$t('1231')" prop="salary_year_accumulate_notfix_tax">
      <el-input
        v-model="staffInfo.salary_year_accumulate_notfix_tax"
        v-enterNumberPoint2
        v-enterNumberMax="1000000000"
        placeholder="0.00"
        :disabled="show"
      ></el-input>
    </el-form-item>
  </div>
</template>
<script>
export default {
  name: 'tax-info',
  components: {},
  props: {
    staffInfo: {
      type: Object,
      default: () => {}
    },
    show: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      calculationRule: {
        // 个人所得税
        3: [{
          text: this.$t('basic_info_7'), // 个人所得税_新法
          value: '3'
        }, {
          text: this.$t('basic_info_8'), // 固定税率
          value: '2'
        }],
        // 预扣税
        4: [{
          text: this.$t('basic_info_4'), // 员工缴纳
          value: '41'
        },
        {
          text: this.$t('basic_info_5'), // 公司缴纳
          value: '42'
        },
        {
          text: this.$t('basic_info_6'), // 公司缴纳-一次
          value: '43'
        }]
      }
    }
  },
  mounted() {},
  methods: {}
}
</script>
<style lang="scss" scoped>
.panel {
  overflow: hidden;
}
.icon {
  width: 16px;
  vertical-align: middle;
  margin-top: -4px;
  margin-left: 5px;
}
.divider {
  color: #262626;
  font-size: 14px;
  line-height: 30px;
  font-weight: 500;
}
</style>
